import React from 'react';
import {tests} from '../../assets/constants/tests';
import Tests from '../../components/Tests/Tests';
const EnterenceTests = () => {
    return (
        <Tests title="Kirish testlari" tests={tests}/>
    );
}

export default EnterenceTests;
